import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

/**
 * 인스펙터 딥링크 (02 §11). `?focus=<entityId>` 로 선택 엔티티를 표현 →
 * 모듈 간 점프가 URL로 일관되게 동작.
 */
export function useFocus(): [string | null, (id: string | null) => void] {
  const [sp, setSp] = useSearchParams();
  const focus = sp.get('focus');
  const setFocus = useCallback(
    (id: string | null) => {
      setSp(
        (prev) => {
          const next = new URLSearchParams(prev);
          if (id) next.set('focus', id);
          else next.delete('focus');
          return next;
        },
        { replace: true },
      );
    },
    [setSp],
  );
  return [focus, setFocus];
}
